var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Session from "js/Session";
import { computed, ref } from "vue";
import _ from "underscore";
import { useUserStore } from ".";
import { getPage } from "../common/pagination";
import { usePersonStore } from "src/shared/store/person/index";
import { useFuzzySearch } from "../common/fuzzy-search";
import { useAsyncPrimer } from "../common/async-primer";
const prepareUserArray = (users) => _.reject(users, (user) => user.isMe()).sort((user1, user2) => {
    var _a, _b, _c, _d;
    const name1 = (_b = (_a = user1.getFullName()) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : user1.email;
    const name2 = (_d = (_c = user2.getFullName()) === null || _c === void 0 ? void 0 : _c.trim()) !== null && _d !== void 0 ? _d : user2.email;
    return name1 === null || name1 === void 0 ? void 0 : name1.localeCompare(name2);
});
export const useNonSuperUsers = () => {
    const userStore = useUserStore();
    return _.reject(userStore.getUsers(), (user) => user.isExtoleUser());
};
export const useSuperUsers = () => {
    const userStore = useUserStore();
    return _.filter(userStore.getUsers(), (user) => user.isExtoleUser());
};
export const useUsers = () => {
    const userStore = useUserStore();
    const meId = Session.getInstance().getUserId();
    const me = userStore.getUser(meId);
    const superUsers = prepareUserArray(useSuperUsers());
    const nonSuperUsers = prepareUserArray(useNonSuperUsers());
    return (me ? [me] : []).concat(nonSuperUsers, superUsers);
};
export const useUserResultSet = () => {
    const userStore = useUserStore();
    const primer = useAsyncPrimer(() => __awaiter(void 0, void 0, void 0, function* () {
        if (_.isEmpty(userStore.getUsers())) {
            yield userStore.fetchUsers(undefined, "store/user/composables");
        }
    }), "useUserResultSet");
    const users = computed(() => userStore.getUsers());
    return {
        users,
        primer,
    };
};
export const filterUserList = (users, parameters, paginationParams) => {
    const filtered = useFuzzySearch(parameters.search, users, [
        "first_name",
        "last_name",
        "email",
    ]);
    return computed(() => getPage(filtered.value, paginationParams.parameters.value));
};
export const useUserLoader = (userId) => {
    const userStore = useUserStore();
    const personStore = usePersonStore();
    const data = ref();
    const loadUser = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield userStore.fetchUser(userId, "store/user/composables");
            data.value = userStore.getUser(userId);
        }
        catch (error) {
            try {
                yield personStore.fetchPerson({ personId: userId });
                data.value = personStore.getPerson(userId);
            }
            catch (personError) {
                data.value = null;
            }
        }
    });
    loadUser();
    return computed(() => data.value);
};
export const useUser = (userId) => {
    const userStore = useUserStore();
    const primer = useAsyncPrimer(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!userStore.getUser(userId)) {
            yield userStore.fetchUser(userId, "store/user/composables");
        }
    }), `user-${userId}`);
    const user = computed(() => {
        return userStore.getUser(userId);
    });
    return {
        user,
        primer,
    };
};
